export const DATIQ_TEMPLATE_TOKEN_START: string = '{{';
export const DATIQ_TEMPLATE_TOKEN_END: string = '}}';
export const datiqTempateCreateToken: (key: string) => string = (
    key: string
): string => `${DATIQ_TEMPLATE_TOKEN_START}${key}${DATIQ_TEMPLATE_TOKEN_END}`;
export const datiqTempateCreateTokenRegex: (key: string) => RegExp = (
    key: string
): RegExp => new RegExp(datiqTempateCreateToken(key), 'gm');
export const extractPathFromToken: (token: string) => string = (
    token: string
): string =>
    token
        .replace(DATIQ_TEMPLATE_TOKEN_END, '')
        .replace(DATIQ_TEMPLATE_TOKEN_START, '');
export const DATIQ_TEMPLATE_TOKEN_REGEX: RegExp = /\{\{[A-Z,a-z,\[\],\.,0-9]*\}\}/gm;
export type DatiqTemplateNonTransformTypes = number | boolean | string;
